var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "frontpage-search" }, [
    _c("div", { staticClass: "frontpage-search__wrapper" }, [
      _c(
        "div",
        {
          staticClass: "search-component",
          class: { "search-component--price-overview": _vm.currentTab == 1 }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _c("div", { staticClass: "search-component__wrapper" }, [
            _c(
              "div",
              { staticClass: "search-component__wrapper__block" },
              [
                _c(
                  "div",
                  { staticClass: "search-component__nav" },
                  _vm._l(_vm.tabs, function(tab, tIndex) {
                    return _c("button", {
                      key: tIndex,
                      class: { current: _vm.currentTab == tIndex },
                      domProps: { textContent: _vm._s(tab) },
                      on: {
                        click: function() {
                          return (_vm.currentTab = tIndex)
                        }
                      }
                    })
                  })
                ),
                _vm._v(" "),
                _c("search-fields", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 0,
                      expression: "currentTab == 0"
                    }
                  ]
                }),
                _vm._v(" "),
                _c("price-overview-fields", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 1,
                      expression: "currentTab == 1"
                    }
                  ]
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "search-component__logos" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("span", {
              staticClass: "search-component__logos__end-text",
              domProps: { textContent: _vm._s(_vm.translations.logo_text_last) }
            })
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-component__logos__grid" }, [
      _c("figure", [
        _c("img", {
          staticClass: "logo-alltours",
          attrs: {
            src: require("./../../../img/logos/logo-white-alltours.svg"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("figure", [
        _c("img", {
          staticClass: "logo-tui",
          attrs: {
            src: require("./../../../img/logos/logo-white-tui.svg"),
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("figure", [
        _c("img", {
          staticClass: "logo-der",
          attrs: {
            src: require("./../../../img/logos/logo-white-der-touristik.svg"),
            alt: ""
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-247feb2b", { render: render, staticRenderFns: staticRenderFns })
  }
}